import script from "./RCR.vue?vue&type=script&setup=true&lang=js"
export * from "./RCR.vue?vue&type=script&setup=true&lang=js"

import "./RCR.vue?vue&type=style&index=0&id=56e2b2d7&scoped=true&lang=css"

import exportComponent from "L:\\vuexiangmu\\oppt2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56e2b2d7"]])

export default __exports__